export default function Spinner({id}) {
    return (
        <img id={id} className="Spinner HideSpinner" alt="Processing..." src="/spinner.png"/>
    )
}

export function ToggleSpinner(id) {
    let spinner = document.getElementById(id)

    if(!spinner) {
        return
    }

    if(spinner.classList.contains("HideSpinner")) {
        spinner.classList.remove("HideSpinner")
        return
    }

    spinner.classList.add("HideSpinner")
}